/* eslint-disable react/no-danger */
import React from 'react';
import { ButtonToolbar, Card, Container } from 'react-bootstrap';

import Slider from 'react-slick';
import circle from '../img/Features/Circles.png';
import Token from '../img/Features/token.svg';
import Arrow from '../img/Features/Vector.svg';
import CrossChain from '../img/Features/crossChain.svg';
import Accelator from '../img/Features/Accelator.svg';
import Click from '../img/Features/oneclick.png';

import './Features.scss';
import '../../node_modules/slick-carousel/slick/slick.css';
import '../../node_modules/slick-carousel/slick/slick-theme.css';
/* eslint-disable react/jsx-props-no-spreading */
const cardArray = [
    {
        id: 'card1',
        img: Token,
        title: 'Tokenized Allocations',
        detail:
            'Reimagining token sale whitelists and allocations  by leveraging the power of NFTs on Solana.'
    },
    {
        id: 'card2',
        img: CrossChain,
        title: 'Cross-chain Pools',
        detail:
            'Built on Solana wormhole, cross-chain pools allow communities from other chains to invest directly into Solana projects.'
    },
    {
        id: 'card3',
        img: Accelator,
        title: 'Accelerator',
        detail:
            'Under Accelerator program - we incubate projects, help with go-to market strategy and provide tools to build fast on Solana.'
    },
    {
        id: 'card4',
        img: Click,
        title: '1-Click Token Deployment',
        detail:
            'Helping project developers build fast and launch faster by automating token infrastructure deployment on Solana.'
    }
];

export default function Features() {
    const [currentSlide, setCurrentSlide] = React.useState(0);

    const settings = {
        dots: true,
        draggable: false,
        arrows: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        pauseOnHover: true,
        swipeToSlide: false,
        beforeChange: (prev, next) => {
            setCurrentSlide(next);
        },
        // eslint-disable-next-line react/display-name
        customPaging: (i) => <div className={(i === currentSlide && 'dots active') || 'dots'} />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    // React.useEffect(() => {
    //     const height = document.getElementById('slider-component').clientHeight;
    //     setSliderHeight(height);
    // }, []);

    return (
        <div className="features w-100 h-100 feature-container" id="Features">
            <img src={circle} alt="circle" className="features__circle" />
            <Container className="w-100 h-100 grid-feature">
                <div className="feature-bg">
                    <h1 className="text-center features__heading">
                        Top <span className="custom-text">Features</span> of SolRazr
                    </h1>
                    <div className="pad-y">
                        <Slider {...settings} id="slider-component">
                            {cardArray.map((item) => (
                                <div key={item.id} className="interaction">
                                    <Card className="p-4 features__card">
                                        <Card.Img
                                            variant="top"
                                            src={item.img}
                                            alt={`${item.id}img`}
                                            className="img-fluid img-bg w-50 mt-1"
                                        />
                                        <Card.Body className="px-0 pb-0">
                                            <Card.Title className="text-secondary manrope-font">
                                                {item.title}
                                            </Card.Title>
                                            <Card.Text className="text-secondary manrope-font detail-text-color">
                                                <span
                                                    dangerouslySetInnerHTML={{
                                                        __html: item.detail
                                                    }}
                                                    className="word-setting">
                                                    {/* {item.detail} */}
                                                </span>
                                            </Card.Text>
                                        </Card.Body>
                                        {/* <Card.Link href="#" className="mt-4 d-flex align-items-center">
                                        <span className="text-danger manrope-font">Learn More</span>
                                        <img
                                            src={Arrow}
                                            alt="arrow"
                                            className="ml-2 manrope-font"
                                        />
                                    </Card.Link> */}
                                    </Card>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </Container>
        </div>
    );
}
